export default "__VITE_ASSET__ce059931__"